// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:48em){.flexible-content+*{margin-top:7.5rem}}.flexible-content .rich-text{margin-top:1rem}.flexible-content .rich-text+.rich-text{margin-top:2.5rem}@media (min-width:48em){.flexible-content .cards-grid{margin-top:5rem}}.flexible-content .cards-grid+.rich-text{margin-top:2.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
